import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  ConnectCustomDomainPayload,
  CustomDomain,
  CustomDomainVerifyResult,
  DomainPurchasePayload,
  DomainPurchaseResponse,
  DomainSearchResult,
  RequestResponse,
} from '@/types';

export const searchDomainAvailability = async (domain: string) => {
  const response = await axiosInstance.get<RequestResponse<DomainSearchResult>>(
    endpoints.domainSearch,
    { params: { domain } }
  );
  return response.data.data;
};

export const purchaseDomain = async (payload: DomainPurchasePayload) => {
  const response = await axiosInstance.post<
    RequestResponse<DomainPurchaseResponse>
  >(endpoints.domainPurchase, payload);
  return response.data;
};

export const connectCustomDomain = async (
  payload: ConnectCustomDomainPayload
) => {
  const response = await axiosInstance.post<RequestResponse<CustomDomain>>(
    endpoints.storeCustomDomain,
    payload
  );
  return response.data;
};

export const verifyCustomDomain = async () => {
  const response = await axiosInstance.post<
    RequestResponse<CustomDomainVerifyResult>
  >(endpoints.storeCustomDomainVerify);
  return response.data;
};

export const removeCustomDomain = async () => {
  const response = await axiosInstance.delete<RequestResponse<null>>(
    endpoints.storeCustomDomain
  );
  return response.data;
};
